import { formatNumber } from "@memorang/helpers/common";
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

const DEFAULT_MAX_ITEMS_PER_SESSION = 50;

type Props = {
	numTotalItemsFiltered: number;
	numItemSelected: number;
	maxItemsPerSession?: number;
};

const SessionItemsAvailabilityCaption = ({
	numTotalItemsFiltered,
	numItemSelected,
	maxItemsPerSession = DEFAULT_MAX_ITEMS_PER_SESSION,
}: Props) => {
	const showWarning = numItemSelected >= maxItemsPerSession;

	const numAvailableText = `${formatNumber(numTotalItemsFiltered)} available`;
	const warningText = `Max ${maxItemsPerSession} items per session (${numAvailableText})`;
	const noItemsText = "No items available, try adjusting your filters";

	const getCaption = () => {
		if (numTotalItemsFiltered === 0) {
			return noItemsText;
		}
		if (showWarning) {
			return warningText;
		}
		return numAvailableText;
	};

	const caption = getCaption();
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="flex-end"
			gap={8}
		>
			{showWarning && (
				<Icon
					color={theme.colors.onSurfaceVariant}
					size={18}
					name="alert-outline"
				/>
			)}
			<Text
				variant="labelSmall"
				style={{
					color: theme.colors.onSurfaceVariant,
				}}
			>
				{caption}
			</Text>
		</Box>
	);
};

export default SessionItemsAvailabilityCaption;
